import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_BASE_URL, LOCALSTORAGES } from "../constants/constant";

export const baseApi = createApi({
  reducerPath: "rootApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,

    prepareHeaders: (headers) => {
      const token = localStorage.getItem(LOCALSTORAGES.TOKEN);
      if (token) {
        headers.set("token", `${token}`);
      }
      return headers;
    },
  }),
  tagTypes: [
    "Campaigns",
    "Tasks",
    "Users",
    "Profile",
    "Notifications",
    "Codes",
  ],

  endpoints: () => ({}),
});

export default baseApi;
